module.exports = __webpack_public_path__ + "static/media/kids-floor.84b87b5e.jpg";